import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import { setup } from "@onmo/auth";
import type { KeycloakManagerOptions } from "@onmo/auth";
import { store } from "./store/store";
import { configureI18n } from "./configs/i18n";
import App from "./App";

configureI18n();

// Setup Auth - Keycloak for web
const authOptions: KeycloakManagerOptions = {
  provider: "keycloak",
  onLoad: "check-sso",
};
setup(store, authOptions);

const root = document.getElementById("root") as HTMLElement;
createRoot(root).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
);
